/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, message, Badge, Segmented, Empty, AutoComplete } from "antd";
import { Collapse, Form, Flex, Row, Col, Space, Select } from "antd";
import { Input, Button, Table, Typography } from "antd";
import {
  SearchOutlined,
  ClearOutlined,
  AppstoreOutlined,
  UnorderedListOutlined,
  EditOutlined,
  PictureOutlined,
} from "@ant-design/icons";
import { MdOutlineLibraryAdd } from "react-icons/md";
import { accessColumn } from "./model";
import OptionService from "../../service/Options.service";
// import dayjs from 'dayjs';
import Itemservice from "../../service/Items.Service";
import { comma, BACKEND_URL_MAIN } from "../../utils/util";
import "./items.css";
const opService = OptionService();
const itemservice = Itemservice();
const mngConfig = {
  title: "",
  textOk: null,
  textCancel: null,
  action: "create",
  code: null,
};

/* ===== Cookie helpers ===== */
const HISTORY_COOKIE = "items_search_history";
const PAGE_COOKIE = "items_pagination";
const HISTORY_MAX = 5;

const getCookieJSON = (name, fallback) => {
  try {
    const m = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return m ? JSON.parse(decodeURIComponent(m[1])) : fallback;
  } catch {
    return fallback;
  }
};

const setCookieJSON = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(JSON.stringify(value))};path=/;max-age=${60 * 60 * 24 * 365}`;
};
const ItemsAccess = () => {
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [accessData, setAccessData] = useState([]);
  const [activeSearch, setActiveSearch] = useState([]);
  const [optionType, setOptionType] = useState([]);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("items-view-mode") || "table"
  );

  const handleViewMode = (mode) => {
    setViewMode(mode);
    localStorage.setItem("items-view-mode", mode);
  };

  /* ===== Search history (cookie) ===== */
  const [searchHistory, setSearchHistory] = useState(
    getCookieJSON(HISTORY_COOKIE, { stcode: [], stname: [] })
  );

  const saveSearchHistory = (values) => {
    const next = { ...searchHistory };
    ["stcode", "stname"].forEach((k) => {
      const val = (values?.[k] || "").trim();
      if (!val) return;
      next[k] = [val, ...(next[k] || []).filter((t) => t !== val)].slice(
        0,
        HISTORY_MAX
      );
    });
    setCookieJSON(HISTORY_COOKIE, next);
    setSearchHistory(next);
  };

  /* ===== Pagination (cookie) ===== */
  const [pagination, setPagination] = useState(
    getCookieJSON(PAGE_COOKIE, { current: 1, pageSize: 10 })
  );

  const handlePageChange = (current, pageSize) => {
    const next = { current, pageSize };
    setCookieJSON(PAGE_COOKIE, next);
    setPagination(next);
  };

  const handleSearch = (save) => {
    form.validateFields().then((v) => {
      const data = { ...v };
      if (save === true) saveSearchHistory(data);
      itemservice
        .search(data, { ignoreLoading: Object.keys(data).length !== 0 })
        .then((res) => {
          const { data } = res.data;

          setAccessData(data);
        })
        .catch((err) => {
          console.log(err);
          message.error("Request error!");
        });
    });
  };

  const handleClear = () => {
    form.resetFields();

    handleSearch();
  };

  const hangleAdd = () => {
    navigate("manage/create", {
      state: {
        config: {
          ...mngConfig,
          title: "เพิ่มสินค้า",
          action: "create",
        },
      },
      replace: true,
    });
  };

  const handleEdit = (data) => {
    // setManageConfig({...manageConfig, title:"แก้ไข Sample Request", action:"edit", code:data?.srcode});
    navigate("manage/edit", {
      state: {
        config: {
          ...mngConfig,
          title: "แก้ไขข้อมูลสินค้า",
          action: "edit",
          code: data?.stcode,
        },
      },
      replace: true,
    });
  };

  const handleView = (data) => {
    const newWindow = window.open("", "_blank");
    newWindow.location.href = `/dln-print/${data.dncode}`;
  };

  const handleDelete = (data) => {
    // startLoading();
    // ctmService.deleted(data?.dncode).then( _ => {
    //     const tmp = accessData.filter( d => d.dncode !== data?.dncode );
    //     setAccessData([...tmp]);
    // })
    // .catch(err => {
    //     console.log(err);
    //     message.error("Request error!");
    // });
  };

  useEffect(() => {
    form.setFieldValue('active_status','Y');
    GetItemsType();
    getData();
  }, []);
  const GetItemsType = () => {
    opService.optionsItemstype().then((res) => {
      let { data } = res.data;
      setOptionType(data);
    });
  };
  const getData = () => {
    handleSearch();
  };
  const FormSearch = (
    <Collapse
      size="small"
      onChange={(e) => {
        setActiveSearch(e);
      }}
      bordered={false}
      activeKey={activeSearch}
      items={[
        {
          key: "1",
          label: (
            <>
              <SearchOutlined />
              <span> ค้นหา</span>
            </>
          ),
          children: (
            <>
              <Form form={form} layout="vertical" autoComplete="off">
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="รหัสสินค้า" name="stcode">
                      <AutoComplete
                        options={(searchHistory.stcode || []).map((t) => ({
                          value: t,
                        }))}
                        onChange={() => handleSearch()}
                        onSelect={() => handleSearch(true)}
                      >
                        <Input
                          placeholder="กรอกรหัสสินค้า"
                          onPressEnter={() => handleSearch(true)}
                        />
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item label="ชื่อสินค้า" name="stname">
                      <AutoComplete
                        options={(searchHistory.stname || []).map((t) => ({
                          value: t,
                        }))}
                        onChange={() => handleSearch()}
                        onSelect={() => handleSearch(true)}
                      >
                        <Input
                          placeholder="กรอกชื่อสินค้า"
                          onPressEnter={() => handleSearch(true)}
                        />
                      </AutoComplete>
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="ประเภทสินค้า"
                      name="typecode"
                      onChange={handleSearch}
                    >
                      <Select
                        size="large"
                        showSearch
                        placeholder="เลือกประเภทสินค้า"
                        onChange={handleSearch}
                        options={optionType.map((item) => ({
                          value: item.typecode,
                          label: item.typename,
                        }))}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={24} sm={8} md={8} lg={8} xl={8}>
                    <Form.Item
                      label="สถานะการใช้งาน"
                      name="active_status"
                      onChange={handleSearch}
                    >
                      <Select
                        size="large"
                        showSearch
                        placeholder="เลือกประเภทสินค้า"
                        onChange={handleSearch}
                        // defaultValue="Y"
                        options={[
                          { value: "Y", label: "เปิดการใช้งาน" },
                          { value: "N", label: "ปิดการใช้งาน" },
                        ]}
                      />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={[8, 8]}>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    {/* Ignore */}
                  </Col>
                  <Col xs={24} sm={8} md={12} lg={12} xl={12}>
                    <Flex justify="flex-end" gap={8}>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        icon={<SearchOutlined />}
                        onClick={() => handleSearch(true)}
                      >
                        ค้นหา
                      </Button>
                      <Button
                        type="primary"
                        size="small"
                        className="bn-action"
                        danger
                        icon={<ClearOutlined />}
                        onClick={() => handleClear()}
                      >
                        ล้าง
                      </Button>
                    </Flex>
                  </Col>
                </Row>
              </Form>
            </>
          ),
          showArrow: false,
        },
      ]}
    />
  );
  const column = accessColumn({ handleEdit, handleDelete, handleView });

  const TitleTable = (
    <Flex className="width-100" align="center">
      <Col span={12} className="p-0">
        <Flex gap={4} justify="start" align="center">
          <Typography.Title className="m-0 !text-zinc-800" level={3}>
            รายการสินค้า
          </Typography.Title>
        </Flex>
      </Col>
      <Col span={12} style={{ paddingInline: 0 }}>
        <Flex gap={8} justify="end" align="center">
          <Segmented
            size="small"
            value={viewMode}
            onChange={handleViewMode}
            options={[
              { value: "table", icon: <UnorderedListOutlined /> },
              { value: "grid", icon: <AppstoreOutlined /> },
            ]}
          />
          <Button
            size="small"
            className="bn-action bn-center bn-primary-outline justify-center"
            icon={<MdOutlineLibraryAdd style={{ fontSize: ".9rem" }} />}
            onClick={() => {
              hangleAdd();
            }}
          >
            เพิ่มสินค้า
          </Button>
        </Flex>
      </Col>
    </Flex>
  );
  return (
    <div className="item-access">
      <Space
        direction="vertical"
        size="middle"
        style={{ display: "flex", position: "relative" }}
      >
        <Card>
          {FormSearch}
          <br></br>
          <Row gutter={[8, 8]} className="m-0">
            <Col xs={24} sm={24} md={24} lg={24} xl={24}>
              {viewMode === "table" ? (
                <Table
                  title={() => TitleTable}
                  size="small"
                  rowKey="stcode"
                  columns={column}
                  dataSource={accessData}
                  pagination={{
                    current: pagination.current,
                    pageSize: pagination.pageSize,
                    showSizeChanger: true,
                    onChange: handlePageChange,
                  }}
                />
              ) : (
                <>
                  <div style={{ padding: "8px 0" }}>{TitleTable}</div>
                  {accessData.length === 0 ? (
                    <Empty />
                  ) : (
                    <Row gutter={[12, 12]}>
                      {accessData.map((item) => (
                        <Col
                          key={item.stcode}
                          xs={24}
                          sm={12}
                          md={8}
                          lg={8}
                          xl={6}
                          xxl={4}
                        >
                          <Card
                            hoverable
                            size="small"
                            className="item-grid-card"
                            onClick={() => handleEdit(item)}
                          >
                            <Flex gap={8} align="start">
                              <div className="item-grid-thumb">
                                {item.file_name ? (
                                  <img
                                    src={`${BACKEND_URL_MAIN}/uploads/${item.file_name}`}
                                    alt={item.stname}
                                    onError={(e) => {
                                      e.currentTarget.style.display = "none";
                                    }}
                                  />
                                ) : (
                                  <PictureOutlined className="item-grid-thumb-icon" />
                                )}
                              </div>
                              <div style={{ flex: 1, minWidth: 0 }}>
                                <Typography.Text
                                  strong
                                  ellipsis={{ tooltip: item.stname }}
                                  style={{ display: "block" }}
                                >
                                  {item.stcode} {item.stname}
                                </Typography.Text>
                                <Typography.Text
                                  type="secondary"
                                  style={{ fontSize: 12, display: "block" }}
                                >
                                  {item.typename || "-"}
                                </Typography.Text>
                                <Typography.Text
                                  type="secondary"
                                  style={{ fontSize: 12, display: "block" }}
                                >
                                  SKU {item.stcode}
                                </Typography.Text>
                              </div>
                            </Flex>
                            <div className="item-grid-unit">
                              {item.unit || "-"}
                            </div>
                            <Flex
                              justify="space-between"
                              align="center"
                              style={{ marginTop: 8 }}
                            >
                              <div>
                                <Typography.Text
                                  strong
                                  style={{ fontSize: 16 }}
                                >
                                  ฿ {comma(Number(item.price || 0), 2, 2)}
                                </Typography.Text>
                                <div style={{ fontSize: 12 }}>
                                  <Typography.Text type="secondary">
                                    สต๊อก {comma(Number(item.stock || 0), 2, 2)}
                                  </Typography.Text>{" "}
                                  {item.active_status === "Y" ? (
                                    <Badge status="success" />
                                  ) : (
                                    <Badge status="error" />
                                  )}
                                </div>
                              </div>
                              <Button
                                icon={<EditOutlined />}
                                className="bn-primary-outline bn-center"
                                size="small"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleEdit(item);
                                }}
                              />
                            </Flex>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  )}
                </>
              )}
            </Col>
          </Row>
        </Card>
      </Space>
    </div>
  );
};

export default ItemsAccess;
